import { render } from "./FollowUp.vue?vue&type=template&id=963bd5cc&scoped=true"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"

import "./FollowUp.vue?vue&type=style&index=0&id=963bd5cc&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963bd5cc"]])

export default __exports__